import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, TableCell, Grid } from "@material-ui/core";

import { EnhancedTable } from "components/Global/Table/EnhancedTable";

const StyledTableCell = styled(TableCell)`&&&& {
                                                  min-width: 275px;
                                                }`;

const SelectedNoItemGrid = styled(Grid)`&&&& {
                                              padding: 12px;
                                              background-color: rgb(242, 242, 242);
                                              font-family: "Roboto Medium", "Roboto Regular", Roboto;
                                              font-weight: 500;
                                              font-style: normal;
                                              font-size: 17px;
                                              color: rgb(153, 153, 153);
                                              width: 1500px;
                                            }`;

const NewButton = styled(Button)`&& {
                                      margin: 0 0 -4px 4px;
                                      padding: 8px 8px 0px 2px;
                                      border-radius: 0;
                                      color: #2196f3;
                                      background: none;
                                    }
                                    & span {
                                      margin-left: 4px;
                                    }
                                    &&:hover {
                                      background: #f6f6f6;
                                    }
                                  `;

export const VerticalDivider = styled.div` {
                                            height: 34px;
                                            border-right: 1px solid #cccccc;
                                           }`;

const EmptyListDiv = styled.div`&& {
                                    margin-top: 17px,
                                    margin-bottom: 17px
                                   }`;


export class GuestTable extends Component {
  tableColumns = (props) => [
    {
      id: 'firstName',
      label: 'Name',
      numeric: false,
      isString: true,
      isDateField: false,      
      cellValueCalculator: guest => `${guest.firstName} ${guest.lastName}`
    },
    {
      id: 'contactcompanyname',
      label: 'Company',
      numeric: false,
      isString: true,
      isDateField: false,
      dataField: 'company'
    },
    {
      id: 'invitedByName',
      label: 'Invited By',
      numeric: false,
      isString: true,
      isDateField: false,
      cellValueCalculator: guest => `${guest.invitedBy.firstName} ${guest.invitedBy.lastName}`,
      isNotFilterable: true
    },
    {
      id: 'dateInvited',
      label: 'Date Invited',
      numeric: false,
      isString: false,
      isDateField: true,
      dataField: 'dateInvited',
      isNotFilterable: true,
    },
    {
      id: 'permissionLevel',
      label: 'Permission Level',
      numeric: false,
      isString: true,
      isDateField: false,
      isNotFilterable: true,
      cellValueCalculator: data => props.isPortfolio ? (data.portfolioPermission ? data.portfolioPermission.value : "--") : (data.pipelinePermission ? data.pipelinePermission.value : "--")
    },
    {
      id: 'actions',
      label: ' ',
      numeric: true,
      isString: false,
      isDateField: false,
      dataField: '',
      width: 320,
      isNotFilterable: true,
      cell: ({ data }) => (
        <StyledTableCell>
          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={8}>
            <Grid item><NewButton variant="contained" onClick={ () => this.props.deleteGuest(data)}><DeleteIcon/></NewButton></Grid>            
          </Grid>
        </StyledTableCell>
      )
    },
  ];

  render() {
    if(!this.props.records) return null;

    if(this.props.records.length == 0) {
      return (<EmptyListDiv>
                {this.props.headerComponent}
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8} style={{paddingBottom:"8px"}}>
                  <SelectedNoItemGrid container item>{`No guests found`}</SelectedNoItemGrid>
                </Grid>
              </EmptyListDiv>)
    } else {
      const tableColumns = this.tableColumns(this.props);
      return (<div style={{width:"100%"}}><EnhancedTable
                columnDefinitions={tableColumns}
                rows={this.props.records}
                orderBy={this.tableColumns[3]}
                order={EnhancedTable.DESC_ORDER}
                shouldHideConfig={true}
                shouldHideExport={true}
                useGridLayout
                searchable
                searchHintText="Search by guest or company"
                noSearchResultsFoundMessage="No guests found"
                noRowsMessage="No guests found"
                width={'98%'}
                overflowY={"inherit"}
                headerComponent={this.props.headerComponent} 
                pageable
                tableConfigItemId="aba3b0b3-e136-481e-8f2b-97c7a34e1f37"
                instanceId={this.props.instanceId}
                /></div>);
    }
  }
}

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(GuestTable);
